import { useCallback } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { getScreenFromUrl } from '@trello/marketing-screens';

import {
  clearQuickCaptureNotifications,
  useQuickCaptureNotifications,
} from './quickCaptureNotificationsState';
import { useTrelloMarkInboxNotificationsReadMutation } from './TrelloMarkInboxNotificationsReadMutation.generated';
import { useIsQuickCaptureInboxNotificationsEnabled } from './useIsQuickCaptureInboxNotificationsEnabled';

const source = getScreenFromUrl();
const taskName = 'edit-notifications/inbox/quickCapture';
export const useDismissQuickCaptureNotifications = () => {
  const quickCaptureNotifications = useQuickCaptureNotifications();
  const [markInboxNotificationsRead] =
    useTrelloMarkInboxNotificationsReadMutation();
  const { value: isQuickCaptureInboxNotificationsEnabled } =
    useIsQuickCaptureInboxNotificationsEnabled();

  const dismissQuickCaptureNotifications = useCallback(async () => {
    if (
      !isQuickCaptureInboxNotificationsEnabled ||
      quickCaptureNotifications.length < 1
    ) {
      return;
    }
    const traceId = Analytics.startTask({
      taskName,
      source,
    });
    // Optimistically update quickCaptureNotificationsState
    clearQuickCaptureNotifications();

    try {
      await markInboxNotificationsRead();
      Analytics.taskSucceeded({
        taskName,
        traceId,
        source,
      });
    } catch (error) {
      Analytics.taskFailed({
        taskName,
        traceId,
        source,
        error,
      });
    }
  }, [
    quickCaptureNotifications,
    markInboxNotificationsRead,
    isQuickCaptureInboxNotificationsEnabled,
  ]);

  return dismissQuickCaptureNotifications;
};
